import {TourSteps} from './interface/tour-steps.interface';
import Step from 'shepherd.js/src/types/step';
import {LocalStorageEnum} from '../../../enums/utils';
import {ToursEnum} from '../../../enums/tour';

export const registerFoodDishStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, services, events, cb}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'FoodDishStep1',
        title: 'Nombra tu receta',
        text: `Escribe el nombre con el que será llamada tu receta, los buscadores usarán este valor para encontrarla.`,
        attachTo: {
          element: '.input-name-food-dish',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'FoodDishStep2',
        title: 'Describe tu receta',
        text: `Agrega una descripción de tu receta, esta descripción será vista por quienes la utilicen.`,
        attachTo: {
          element: '.input-description-food-dish',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'FoodDishStep3',
        title: '¿Deseas compartir tu receta?',
        text: `Puedes hacer que tu receta sea visible para otros expertos de la clínica o si lo prefieres puedes mantenerla como privado y solo tú podrás utilizarla.`,
        attachTo: {
          element: '.switch-share-food-dish',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'FoodDishStep4',
        title: 'Categorías',
        text: `Puedes añadir una o varias categorías a tu receta. Da clic para continuar.`,
        attachTo: {
          element: '.add-category-btn',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.add-category-btn',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'FoodDishStep5',
        title: 'Selecciona la categoría',
        text: `Elige la o las categorías que represente más a tu receta. En los buscadores también se pueden filtrar las recetas por categoría. Elige una o más para continuar.`,
        attachTo: {
          element: '.ant-select-dropdown',
          on: 'top'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action() {
              events.events.next('closeCategorySelectElement');
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel},
        ],
        classes: undefined,
        modalOverlayOpeningPadding: 0,
      },
      {
        ...steps.default,
        id: 'FoodDishStep6',
        title: '¡Ahora vamos a lo bueno!',
        text: `Toda receta se conforma de ingredientes, vamos entonces a añadir nuestro primer ingrediente. Para fines del tour solo vamos a agregar un ingrediente pero recuerda que siempre puedes regresar y modificar tus recetas. Da clic para continuar.`,
        attachTo: {
          element: '.btn-add-food',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-add-food',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'FoodDishStep7',
        title: 'Busca tu primer ingrediente',
        text: `Da clic para abrir un buscador y elegir el primer ingrediente. Cada ingrediente muestra sus propiedades nutricionales, ¡es genial!`,
        attachTo: {
          element: '.input-add-food',
          on: 'bottom'
        },
        canClickTarget: true,
        advanceOn: {
          selector: '.input-add-food',
          event: 'click'
        },
        buttons: [
          {...buttons.cancel}
        ],
        beforeShowPromise: async () => {
          events.events.emit('setFindIngredient');
          return new Promise((resolve): void => {
            setTimeout((): void => {
              resolve(true);
            }, 500);
          });
        }
      },
      {
        ...steps.default,
        id: 'FoodDishStep8',
        title: '¡Muy bien ahora solo selecciona el ingrediente!',
        text: `Ya casi completamos el tour, elige bien tu primer ingrediente. Recuerda que después del tour podrás agregar más ingredientes a la receta.`,
        attachTo: {
          element: '.ant-select-dropdown',    // @ts-ignore
          on: 'top'
        },
        advanceOn: {
          selector: '.ant-select-dropdown',
          event: 'click',
        },
        buttons: [{...buttons.cancel}],
        classes: undefined,
        modalOverlayOpeningPadding: 0,
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'FoodDishStep9',
        title: '¡Agregalo!',
        text: `Conforme agregues ingredientes se listarán para luego poder guardarlos.`,
        attachTo: {
          element: '.btn-save-add-food',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-save-add-food',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
        beforeShowPromise: () => {
          events.events.emit('closeIngredientSelectElement');
          return new Promise((resolve): void => {
            setTimeout((): void => {
              resolve(true);
            }, 500);
          });
        },
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'FoodDishStep10',
        title: 'Guarda tu receta',
        // text: `Si ya tienes los datos válidos puedes guardar tu receta.`,
        text: 'Una vez que hayas ingresado los datos de la receta, tendrás que dar clic en el botón para poder guardar los datos.',
        attachTo: {
          element: '.btn-save-food-dish',
          on: 'bottom'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action() {
              if (services.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_FOOD_DISH) {
                return this.next();
              } else {
                cb('saveRecipe');
              }
            },
            text: 'Entendido'
          },
          {...buttons.cancel},
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            setTimeout((): void =>  {
              resolve(true);
            }, 1000);
          });
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'FoodDishStep12',
        title: 'Tour finalizado',
        text: '¡Muy bien!. Has finalizado el tour de "Crear receta".',
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('goToTours');
            },
            text: 'Ir al listado de tours',
            classes: 'shepherd-button shepherd-button-secondary',
          },
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('completeTour');
            },
            text: 'Mantenerme aquí'
          },
          {...buttons.cancel}
        ]
      }
    ];
  };
